import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { ApiErrorResponseFromJSON } from '@ibe/api';
import { removeTrailingSlashes } from '@ibe/services';
import CmsPackage from '../Models/CMS/CmsPackage';
import i18next from 'i18next';

class CmsPackageService {
  private _apiUrl: string;

  public _package: CmsPackage | undefined;

  private packageUrl = '/cms/package';

  private packageAccessVerificationUrl = '/cms/package/verifyAccess';

  private packageAnnualPassAccessVerificationUrl = '/cms/package/verifyAnnualPassAccess';

  constructor() {
    makeObservable(this, {
      _package: observable,
      package: computed,
      fetchPackage: action
    });
  }

  get package(): CmsPackage | undefined {
    return this._package;
  }

  set apiUrl(value: string) {
    this._apiUrl = removeTrailingSlashes(value);
  }

  async fetchPackage(code: string): Promise<CmsPackage | undefined> {
    let result: CmsPackage | undefined;
    try {
      const response = await fetch(this._apiUrl + this.packageUrl + '/' + code, {
        headers: {
          'Accept-Language': i18next.language
        }
      });
      if (response) {
        const jsonResponse = await response.json();
        if (
          jsonResponse &&
          Object.entries(jsonResponse) &&
          Object.entries(jsonResponse).length > 0
        ) {
          result = jsonResponse;
        }
      }
    } catch (e) {
      result = undefined;
      throw ApiErrorResponseFromJSON(e);
    }
    runInAction(() => {
      this._package = result;
    });
    return this._package;
  }

  async verifyAccess(packageCode: string, matchCode: string): Promise<Boolean> {
    try {
      const rq = JSON.stringify({ packageCode: packageCode, matchCode: matchCode });
      const response = await fetch(this._apiUrl + this.packageAccessVerificationUrl, {
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: rq
      });
      if (response) {
        const jsonResponse = await response.json();
        return Promise.resolve(jsonResponse);
      }
      return Promise.reject();
    } catch (e) {
      throw ApiErrorResponseFromJSON(e);
    }
  }

  async verifyAnnualPassAccess(packageCode: string, annualPassCode: string): Promise<Boolean> {
    try {
      const rq = JSON.stringify({ packageCode: packageCode, annualPassCode: annualPassCode });
      const response = await fetch(this._apiUrl + this.packageAnnualPassAccessVerificationUrl, {
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: rq
      });
      if (response) {
        const jsonResponse = await response.json();
        return Promise.resolve(jsonResponse);
      }
      return Promise.reject();
    } catch (e) {
      throw ApiErrorResponseFromJSON(e);
    }
  }
}

export default CmsPackageService;
